"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _base = _interopRequireDefault(require("@emotion/styled/base"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _Box = _interopRequireDefault(require("@material-ui/core/Box"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
} // COMPONENT STYLES


var Label = ( /*#__PURE__*/0, _base.default)(_Box.default, process.env.NODE_ENV === "production" ? {
  target: "e1ln9zhe1"
} : {
  target: "e1ln9zhe1",
  label: "Label"
})(process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9jb21wb25lbnRzL1NhbGVGbGFnL1NhbGVGbGFnLmpzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFNeUIiLCJmaWxlIjoiLi4vLi4vc3JjL2NvbXBvbmVudHMvU2FsZUZsYWcvU2FsZUZsYWcuanN4Iiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IFJlYWN0IGZyb20gJ3JlYWN0J1xuaW1wb3J0IHN0eWxlZCBmcm9tICdAZW1vdGlvbi9zdHlsZWQnXG5pbXBvcnQgeyBzdHJpbmcgfSBmcm9tICdwcm9wLXR5cGVzJ1xuaW1wb3J0IEJveCBmcm9tICdAbWF0ZXJpYWwtdWkvY29yZS9Cb3gnXG5cbi8vIENPTVBPTkVOVCBTVFlMRVNcbmNvbnN0IExhYmVsID0gc3R5bGVkKEJveClgYFxuY29uc3QgUGFyZW50ID0gc3R5bGVkKCdkaXYnKSgocHJvcHMpID0+IHtcbiAgY29uc3QgeyBwYWxldHRlLCB0eXBvZ3JhcGh5IH0gPSBwcm9wcy50aGVtZVxuICByZXR1cm4ge1xuICAgIGZvbnRGYW1pbHk6IHR5cG9ncmFwaHkuZm9udEZhbWlseSxcbiAgICBiYWNrZ3JvdW5kQ29sb3I6IHBhbGV0dGUud2FybmluZy5tYWluLFxuICAgIGNvbG9yOiBwYWxldHRlLnRlcnRpYXJ5LndoaXRlLFxuICAgIHBvc2l0aW9uOiAnYWJzb2x1dGUnLFxuICAgIHRvcDogMTAsXG4gICAgbGVmdDogMTAsXG4gICAgekluZGV4OiA1LFxuICAgIHBhZGRpbmc6ICc4cHggMTZweCcsXG4gICAgYm9yZGVyUmFkaXVzOiA1LFxuICAgIFtMYWJlbF06IHtcbiAgICAgIGZvbnRTaXplOiAxNixcbiAgICAgIGZvbnRXZWlnaHQ6IDYwMCxcbiAgICAgIHRleHRUcmFuc2Zvcm06ICd1cHBlcmNhc2UnLFxuICAgIH0sXG4gIH1cbn0pXG5cbi8vIFRvZG86IHVzZSBNdWkgdHlwb2dyYXBoeVxuY29uc3QgU2FsZUZsYWcgPSAoeyBsYWJlbCwgdGVzdElkIH0pID0+IChcbiAgPFBhcmVudCBkYXRhLXRlc3RpZD17dGVzdElkfT5cbiAgICA8TGFiZWwgZm9udFNpemU9ezIwfT57bGFiZWx9PC9MYWJlbD5cbiAgPC9QYXJlbnQ+XG4pXG5cblNhbGVGbGFnLnByb3BUeXBlcyA9IHtcbiAgbGFiZWw6IHN0cmluZyxcbiAgdGVzdElkOiBzdHJpbmcsXG59XG5cblNhbGVGbGFnLmRlZmF1bHRQcm9wcyA9IHtcbiAgdGVzdElkOiAnc2FsZUZsYWcnLFxufVxuXG5leHBvcnQgZGVmYXVsdCBTYWxlRmxhZ1xuIl19 */");
var Parent = ( /*#__PURE__*/0, _base.default)('div', process.env.NODE_ENV === "production" ? {
  target: "e1ln9zhe0"
} : {
  target: "e1ln9zhe0",
  label: "Parent"
})(function (props) {
  var _props$theme = props.theme,
      palette = _props$theme.palette,
      typography = _props$theme.typography;
  return _defineProperty({
    fontFamily: typography.fontFamily,
    backgroundColor: palette.warning.main,
    color: palette.tertiary.white,
    position: 'absolute',
    top: 10,
    left: 10,
    zIndex: 5,
    padding: '8px 16px',
    borderRadius: 5
  }, Label, {
    fontSize: 16,
    fontWeight: 600,
    textTransform: 'uppercase'
  });
}, process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9jb21wb25lbnRzL1NhbGVGbGFnL1NhbGVGbGFnLmpzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFPZSIsImZpbGUiOiIuLi8uLi9zcmMvY29tcG9uZW50cy9TYWxlRmxhZy9TYWxlRmxhZy5qc3giLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgUmVhY3QgZnJvbSAncmVhY3QnXG5pbXBvcnQgc3R5bGVkIGZyb20gJ0BlbW90aW9uL3N0eWxlZCdcbmltcG9ydCB7IHN0cmluZyB9IGZyb20gJ3Byb3AtdHlwZXMnXG5pbXBvcnQgQm94IGZyb20gJ0BtYXRlcmlhbC11aS9jb3JlL0JveCdcblxuLy8gQ09NUE9ORU5UIFNUWUxFU1xuY29uc3QgTGFiZWwgPSBzdHlsZWQoQm94KWBgXG5jb25zdCBQYXJlbnQgPSBzdHlsZWQoJ2RpdicpKChwcm9wcykgPT4ge1xuICBjb25zdCB7IHBhbGV0dGUsIHR5cG9ncmFwaHkgfSA9IHByb3BzLnRoZW1lXG4gIHJldHVybiB7XG4gICAgZm9udEZhbWlseTogdHlwb2dyYXBoeS5mb250RmFtaWx5LFxuICAgIGJhY2tncm91bmRDb2xvcjogcGFsZXR0ZS53YXJuaW5nLm1haW4sXG4gICAgY29sb3I6IHBhbGV0dGUudGVydGlhcnkud2hpdGUsXG4gICAgcG9zaXRpb246ICdhYnNvbHV0ZScsXG4gICAgdG9wOiAxMCxcbiAgICBsZWZ0OiAxMCxcbiAgICB6SW5kZXg6IDUsXG4gICAgcGFkZGluZzogJzhweCAxNnB4JyxcbiAgICBib3JkZXJSYWRpdXM6IDUsXG4gICAgW0xhYmVsXToge1xuICAgICAgZm9udFNpemU6IDE2LFxuICAgICAgZm9udFdlaWdodDogNjAwLFxuICAgICAgdGV4dFRyYW5zZm9ybTogJ3VwcGVyY2FzZScsXG4gICAgfSxcbiAgfVxufSlcblxuLy8gVG9kbzogdXNlIE11aSB0eXBvZ3JhcGh5XG5jb25zdCBTYWxlRmxhZyA9ICh7IGxhYmVsLCB0ZXN0SWQgfSkgPT4gKFxuICA8UGFyZW50IGRhdGEtdGVzdGlkPXt0ZXN0SWR9PlxuICAgIDxMYWJlbCBmb250U2l6ZT17MjB9PntsYWJlbH08L0xhYmVsPlxuICA8L1BhcmVudD5cbilcblxuU2FsZUZsYWcucHJvcFR5cGVzID0ge1xuICBsYWJlbDogc3RyaW5nLFxuICB0ZXN0SWQ6IHN0cmluZyxcbn1cblxuU2FsZUZsYWcuZGVmYXVsdFByb3BzID0ge1xuICB0ZXN0SWQ6ICdzYWxlRmxhZycsXG59XG5cbmV4cG9ydCBkZWZhdWx0IFNhbGVGbGFnXG4iXX0= */"); // Todo: use Mui typography

var SaleFlag = function SaleFlag(_ref2) {
  var label = _ref2.label,
      testId = _ref2.testId;
  return /*#__PURE__*/_react.default.createElement(Parent, {
    "data-testid": testId
  }, /*#__PURE__*/_react.default.createElement(Label, {
    fontSize: 20
  }, label));
};

SaleFlag.propTypes = {
  label: _propTypes.string,
  testId: _propTypes.string
};
SaleFlag.defaultProps = {
  testId: 'saleFlag'
};
var _default = SaleFlag;
exports.default = _default;